import { Box, BoxProps } from '@mui/material';
import clsx from 'clsx';
import { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import style from './index.module.scss';

export interface AppScrollbarsProps extends BoxProps {
  className?: string;
  mode?: 'hover' | 'hide';
  size?: 'small' | 'medium';
}

const Component = (
  { className, children, mode = 'hover', size = 'medium', ...rest }: AppScrollbarsProps,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const trackVisibilityClass = useMemo(() => {
    switch (mode) {
      case 'hover':
        return style.hover;
      case 'hide':
        return style.hide;
      default:
        return null;
    }
  }, [mode]);
  const sizeCLass = useMemo(() => {
    switch (size) {
      case 'small':
        return style.small;
      default:
        return null;
    }
  }, [size]);
  return (
    <Box
      ref={ref}
      height={'100%'}
      overflow={'auto'}
      position={'relative'}
      className={clsx(style.root, className, trackVisibilityClass, sizeCLass)}
      {...rest}
    >
      <Box className={style.wrapper}>
        {children}
      </Box>
    </Box>
  );
};

export const AppScrollbars = memo(forwardRef(Component));
